module.exports = fox._r("fonts/ropasoftpro-regular-webfont.svg", __webpack_public_path__ + "fonts/ropasoftpro-regular-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/ropasoftpro-regular-webfont.svg
// module id = 963
// module chunks = 4